import React, { useState } from 'react';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import { BusinessArea } from '../../../../Enums/BusinessArea';
import { getBusinessAreaByChannel } from '../../../../Helpers/AgentHelper';
import { isAgentActive } from '../../../../Helpers/AgentHelper';
import './Styles.css';
import HistoricalAgentInfo from './HistoricalAgentInfo/HistoricalAgentInfo';

const HistoricalAgents = ({ team }) => {
  const [selectedAgent, setSelectedAgent] = useState(null);

  const historicalAgents = team?.agents?.filter(agent => !isAgentActive(agent));

  return (
    <div className="teamPage-historicalAgents-container">
      {selectedAgent !== null && (
        <HistoricalAgentInfo
          agent={selectedAgent}
          closeView={() => {
            setSelectedAgent(null);
          }}
          team={team}
        />
      )}
      {historicalAgents && historicalAgents.length > 0 && (
        <>
          <div className="common-table-row teamPage-historicalAgents-tableRow headerRow">
            <div>{formatMessage(Messages.common_agentCode)}</div>
            <div>{formatMessage(Messages.common_costCenter)}</div>
            <div>{formatMessage(Messages.common_externalSalesCode)}</div>
            <div>{formatMessage(Messages.common_additionalName)}</div>
            <div>{formatMessage(Messages.common_activationDate)}</div>
            <div>{formatMessage(Messages.historicalAgents_endDate)}</div>
          </div>

          {historicalAgents.map((agent, index) => (
            <div
              className={`common-table-row clickable teamPage-historicalAgents-tableRow ${
                index % 2 === 1 ? 'common-table-evenRow' : ''
              }`}
              key={index}
              onClick={() => {
                setSelectedAgent(agent);
              }}>
              <div>{agent.code}</div>
              <div>{agent.costCenter?.name}</div>
              <div>{agent.externalSalesCode ? agent.externalSalesCode : '—'}</div>
              {(getBusinessAreaByChannel(agent.channel) ?? this.context?.businessArea) === BusinessArea.Commercial ? (
                <div>{agent.additionalName}</div>
              ) : (
                <div>{formatMessage(Messages.activeAgents_notApplicable)}</div>
              )}
              <div>{agent.validFrom}</div>
              <div>{agent.validTo}</div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default HistoricalAgents;
